export default __webpack_public_path__ + "static/215-e1c4abd28a9fcb70d18ee262f52ca030.gif";